import { render } from "./StockReservedActivity.vue?vue&type=template&id=04c83a6b"
import script from "./StockReservedActivity.vue?vue&type=script&lang=js"
export * from "./StockReservedActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__